import { useState, useEffect } from "react";
import login from "../utils/login";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import NoChallengesAvailable from '../components/NoChallengesAvailable';

function LogIn() {

    useEffect(() => {

      if (Cookies.get('authToken')) {
        navigate('/home');
      }


    }, [])
  

    const [formData, setFormData] = useState({
        username: "",
        password: "",
      });
    
      const handleFormInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      };
      const navigate = useNavigate();

      const attemptLogin = (e) => {
        login(formData).then((response) => 
        {    
            const authToken = response.data.token;
            Cookies.set("authToken", authToken, {expires: 7} )

         navigate("/home")    
        }
        ).catch((error) => {
            toast.error("Unable to log in.");
            });
      }

    return(
        <div style={{ backgroundColor:'#F9F6EE', height: '100vh'}}>
          <div style={{ paddingBelow: "25%"}}><NoChallengesAvailable text="Kluch Daily" /></div>
        <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div
                className="card-body"
                style={{ backgroundColor: "skyblue", borderRadius: "5px" }}
              >
                <h2 className="card-title text-center mb-4">Log In</h2>
                <form>
                  <div className="mb-3">
                    <label htmlFor="username" className="form-label">
                      Username
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="username"
                      name="username"
                      placeholder="Username"
                      onChange={handleFormInputChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="username" className="form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      name="password"
                      placeholder="Password"
                      onChange={handleFormInputChange}
                    />
                  </div>
                 

               
                  <button
                    type="button"
                    onClick={attemptLogin}
                    className="btn btn-primary w-100"
                  >
                    Login
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
        </div>
    );
}

export default LogIn;